import { render, staticRenderFns } from "./RelationDisplayName.vue?vue&type=template&id=3f633023&scoped=true&"
import script from "./RelationDisplayName.vue?vue&type=script&lang=ts&"
export * from "./RelationDisplayName.vue?vue&type=script&lang=ts&"
import style0 from "./RelationDisplayName.vue?vue&type=style&index=0&id=3f633023&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f633023",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
